import Characters from "../Components/Characters";
import './Pages.css';
import React from "react";
import { useState, useEffect, useCallback } from "react";
import { practiceparagraphs } from "../Components/Paragraphs";
import { Link } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";

let ranIndex = Math.floor(Math.random() * practiceparagraphs.length);

const PracticeBoard = () => {
  const [word, setWord] = useState('');
  const [para, setPara] = useState(practiceparagraphs[ranIndex]);
  const [chrIndex, setChrIndex] = useState(0);
  const [WPM, setWPM] = useState(0);
  const [errors, setErrors] = useState(0);
  const [accuracy, setAccuracy] = useState(100);

  const handleWordType = (e) => {
    const { value } = e.target;
    setWord(value);
    setChrIndex(value.length);

    const wordsTyped = (value.length - errors) / 5;
    setWPM(Math.max(wordsTyped, 0)); // Ensure WPM is not below 0

    const lastChar = value[value.length - 1];
    if (lastChar && para[value.length - 1] !== lastChar) {
      setErrors(errors + 1);
    }

    const newAccuracy = ((value.length - errors) / value.length) * 100;
    setAccuracy(Math.max(newAccuracy, 0)); // Ensure accuracy is not below 0
  };

  const callbackRef = useCallback((input) => {
    if (input) {
      input.focus();
    }
  }, []);

  useEffect(() => {
    const handleKeyDown = () => {
      if (callbackRef) {
        callbackRef();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [callbackRef]);

  const handleRestart = () => {
    let ri = Math.floor(Math.random() * practiceparagraphs.length);
    if (ri !== ranIndex) {
      ranIndex = ri;
      setPara(practiceparagraphs[ri]);
      setWord('');
      setChrIndex(0);
      setWPM(0);
      setErrors(0);
      setAccuracy(100);
    }
  };

  return (
    <>
    
      <div className="practiceB-css bg-ctr">
      <div className="go-back">
      <Link to="/" style={{color:"white"}}><BsArrowLeft />
      </Link>
        </div>
        <div className="wpm-acc">
          <p>
            {Math.floor(WPM)}
            <small> WPM</small>
          </p>
          <p>
            {Math.floor(accuracy)}%
            <small> Accuracy</small>
          </p>
        </div>
        <input
          type='text'
          value={word}
          autoFocus
          onChange={handleWordType}
          ref={callbackRef}
          style={{ opacity: 0 }}
        />
        <Characters
          para={para}
          word={word}
          chrIndex={chrIndex}
          handleRestart={handleRestart}
        />
      </div>
    </>
  );
};

export default PracticeBoard;
